import type { Runtime, RunDTO } from "@roomate/core";

export const RUNTIME_LABEL: Record<Runtime, string> = {
  "claude-code": "Claude Code",
  codex: "Codex",
  cursor: "Cursor",
  antigravity: "Antigravity",
  vscode: "VS Code",
  other: "Other",
};

/** Display name for the CLI that ran a run. Null for rows written before the field existed: we don't guess. */
export function runtimeLabel(run: Pick<RunDTO, "runtime">): string | null {
  if (!run.runtime) return null;
  return RUNTIME_LABEL[run.runtime] ?? run.runtime; // ?? covers a newer hub sending a runtime this build doesn't know
}

/** True when this run took over from a superseded run on another runtime (docs/specs/runtime-fallback.md §4.4). */
export function isFallbackRun(run: Pick<RunDTO, "fallbackFrom">): boolean {
  return Boolean(run.fallbackFrom);
}
